import { t } from "ttag";

import { useServerModals } from "@/features/server-modals/hooks";
import { SERVER_MODAL_ICON } from "@/features/server-modals/models";
import { LogoLoader } from "@/shared/components";
import {
  Button,
  CalendarIcon,
  CardIcon,
  Dialog,
  DocumentAddIcon,
  GraphIcon,
  HeartsIcon,
  InfoCircleIcon,
  LightbulbIcon,
  MapPointIcon,
  PillsIcon,
  ShieldWarningIcon,
  StethoscopeIcon,
  TestTubeIcon,
  UserIcon,
  VideoCameraIcon,
} from "@/shared/ui";

const ICON_MAP = {
  [SERVER_MODAL_ICON.VIDEO]: VideoCameraIcon,
  [SERVER_MODAL_ICON.FORM]: DocumentAddIcon,
  [SERVER_MODAL_ICON.LIGHTBULB]: LightbulbIcon,
  [SERVER_MODAL_ICON.WARNING]: ShieldWarningIcon,
  [SERVER_MODAL_ICON.HEART]: HeartsIcon,
  [SERVER_MODAL_ICON.TRACKER]: GraphIcon,
  [SERVER_MODAL_ICON.LAB]: TestTubeIcon,
  [SERVER_MODAL_ICON.PILLS]: PillsIcon,
  [SERVER_MODAL_ICON.CALENDAR]: CalendarIcon,
  [SERVER_MODAL_ICON.ADDRESS]: MapPointIcon,
  [SERVER_MODAL_ICON.PRESCRIPTION]: StethoscopeIcon,
  [SERVER_MODAL_ICON.CREDIT_CARD]: CardIcon,
  [SERVER_MODAL_ICON.UNSUBSCRIBE]: InfoCircleIcon,
  [SERVER_MODAL_ICON.USER]: UserIcon,
} as const;

export const ServerModal = () => {
  const { firstServerModal, isClosing, closeServerModal } = useServerModals();

  if (!firstServerModal) {
    return null;
  }

  return (
    <Dialog.Root open={Boolean(firstServerModal)}>
      <Dialog.Content withCloseButton={false}>
        <Dialog.Header
          icon={ICON_MAP[firstServerModal.icon ?? SERVER_MODAL_ICON.LIGHTBULB]}
        >
          <Dialog.Title>{firstServerModal?.title}</Dialog.Title>

          <Dialog.Description>{firstServerModal?.body}</Dialog.Description>
          <Dialog.Description>{firstServerModal?.footer}</Dialog.Description>
        </Dialog.Header>

        <Dialog.Footer>
          <Button size="lg" onClick={closeServerModal}>
            {t`Got it!`}
          </Button>
        </Dialog.Footer>

        <LogoLoader show={isClosing} fullscreen />
      </Dialog.Content>
    </Dialog.Root>
  );
};
